export const emailLink = 'online@best.com.pl';
export const phoneNumber = '+48588826200';
export const phoneNumberString = '+ 48 58 882 62 00';
export const pageLink = 'https://online.best.com.pl';
export const mainPageLink = 'https://www.best.com.pl';
export const contactLink = 'korespondencja@best.com.pl';
export const goodPractisesLink =
  'https://www.zpf.pl/etyka/zasady-dobrych-praktyk';
